export function supportsMediaConstraintInspection() {
  if (typeof navigator === 'undefined') return false;

  return typeof navigator.mediaDevices?.getSupportedConstraints === 'function';
}
